/**
 * Looks for elements with data behavior "react" and renders them on the page.
 */
import $ from "jquery";
import React from "react";
import ReactDOM from "react-dom";

function addBehavior(element) {
  var className = element.data("class");
  var htmlElement = element[0];
  var props = element.data("props");
  var constructor = require(`portal/${className}.jsx`).default;

  ReactDOM.render(React.createElement(constructor, props), htmlElement);
}

$(function() {
  let elements = $(`[data-behavior*='react']`);
  for(let element of elements) {
    addBehavior($(element));
  }
});



// WEBPACK FOOTER //
// ./app/javascript/portal/react.js